import React from 'react';
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import HeroBanner from './components/Hero/HeroBanner.jsx';
import MissionSection from './components/MissionSection.jsx';
import ServiceNotice from './components/ServiceNotice.jsx';
import LabsSection from './components/LabsSection/LabsSection.jsx';
import WhyLabsSection from './components/WhyLabsSection.jsx';
import Footer from '../../components/Footer/Footer';
import heroImg from './components/assets/hp.png';

function LabSetup() {
  return (
    <div>
      <Header />
      <Navbar />
      <HeroBanner robotImage={heroImg} />
      <MissionSection />
      <ServiceNotice />
      <LabsSection />
      <WhyLabsSection />
      <Footer
        ctaHeading={"Have Questions About Our\nLab Setup Services?"}
        ctaSub={"Feel free to reach out to us for any queries or guidance.\nOur team is here to help you set up the right lab for your institution."}
      />
    </div>
  );
}

export default LabSetup;